@if (spaceLoaded) {
  <div class="tea-space-detail">
    <app-space-detail-info [spaceDetail]="spaceDetail"></app-space-detail-info>
    <div class="tab-view">
      <app-tab-view [tabOptions]="tabOptions"></app-tab-view>
    </div>
    <div class="detail-content">
      @switch (currentTab) {
        @case ('works') {
          <app-space-delivered-works></app-space-delivered-works>
        }
        @case ('albums') {
          <app-space-albums [spaceMemberNumber]="spaceDetail.users_count"></app-space-albums>
        }
        @case ('timeline') {
          <app-space-timeline></app-space-timeline>
        }
        @case ('activity_records') {
          <app-space-public-activity-records></app-space-public-activity-records>
        }
        @case ('graduation_message') {
          <app-space-graduation-message></app-space-graduation-message>
        }
      }
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
